import { render, staticRenderFns } from "./discountSet.vue?vue&type=template&id=37b42276&scoped=true&"
import script from "./discountSet.vue?vue&type=script&lang=js&"
export * from "./discountSet.vue?vue&type=script&lang=js&"
import style0 from "./discountSet.vue?vue&type=style&index=0&id=37b42276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b42276",
  null
  
)

export default component.exports